module.exports = __webpack_public_path__ + "img/1w.fa544bf3.svg";